"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useLazyLoading(prefix) {
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    ref = _useState2[0],
    setRef = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    items = _useState4[0],
    setItems = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    loaded = _useState6[0],
    setLoaded = _useState6[1];
  var _useState7 = (0, _react.useState)({}),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    visibleItemsMap = _useState8[0],
    setVisibleItemsMap = _useState8[1];
  var itemsVisibilityRef = (0, _react.useRef)({});
  var registerLazyLoadedContainer = function registerLazyLoadedContainer(ref) {
    setRef(ref);
  };
  var updateItems = function updateItems(updatedItems) {
    setItems(updatedItems);
  };
  var onIntersection = function onIntersection(entries) {
    entries.forEach(function (entry, index) {
      var id = entry.target.id.replace(prefix, '');
      itemsVisibilityRef.current[id] = entry.isIntersecting;
      if (index + 1 === items.length) {
        setLoaded(true); // needed this for us to run the visibility for the first time
      }
    });
  };

  var observer = new window.IntersectionObserver(onIntersection, {
    root: null,
    threshold: 0.2
  });
  (0, _react.useEffect)(function () {
    if (!ref.current) return;
    var temp = _objectSpread({}, visibleItemsMap);
    var elem = ref.current;
    var canScroll = elem.scrollHeight > elem.clientHeight + 50;
    var _iterator = _createForOfIteratorHelper(items),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        temp[item._id] = visibleItemsMap[item._id] || !canScroll;
        var foundElement = document.querySelector("#".concat(prefix).concat(item._id));
        if (foundElement) {
          observer.observe(foundElement);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    setVisibleItemsMap(temp);
    // eslint-disable-next-line
  }, [items]);
  (0, _react.useEffect)(function () {
    var elem = ref.current;
    if (elem) {
      var timer = null;
      var onScroll = function onScroll() {
        if (timer !== null) {
          clearTimeout(timer);
        }
        timer = setTimeout(function () {
          setVisibleItemsMap(_objectSpread({}, itemsVisibilityRef.current));
        }, 150);
      };
      elem.addEventListener('scroll', onScroll, false);
      return function () {
        elem.removeEventListener('scroll', onScroll, false);
      };
    }
  }, [ref]);
  (0, _react.useEffect)(function () {
    if (loaded) {
      setVisibleItemsMap(_objectSpread({}, itemsVisibilityRef.current));
    }
  }, [loaded]);
  return {
    registerLazyLoadedContainer: registerLazyLoadedContainer,
    loaded: loaded,
    updateItems: updateItems,
    visibleItemsMap: visibleItemsMap
  };
}
var _default = exports["default"] = useLazyLoading;